/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react';
import Button from 'components/common/Button';
import { Mobile } from 'components/common/Responsive';

const Section2 = () => {
  const { mq } = useTheme();

  const section2Style = css`
    padding: 96px 0px;
    background: #6079ff;
    text-align: center;
    color: #fff;
    .title {
      font-size: 36px;
      font-weight: 600;
      line-height: 54px;
    }
    .text {
      font-size: 18px;
      font-weight: 200;
      line-height: 28px;
      margin-top: 12px;
    }
    button {
      margin-top: 24px;
    }
    ${mq.mobile} {
      .title {
        font-size: 24px;
        line-height: 36px;
      }
      .text {
        font-size: 14px;
        line-height: 21px;
      }
    }
  `;
  return (
    <div css={section2Style}>
      <div className="title">몰파이로 나만의 커머스를 시작하세요</div>
      <div className="text">
        파트너 회원이 되어 나만의 쇼핑몰을 만들거나,
        <br />
        입점사인 경우 몰파이의 다양한 쇼핑몰에 상품을 올리고
        <Mobile>
          <br />
        </Mobile>
        판매할 수 있습니다.
      </div>
      <Button
        color="white"
        onClick={() =>
          window.open('https://partner.mallpie.kr/auth/login', '_blank')
        }
      >
        몰파이 파트너 되기
      </Button>
    </div>
  );
};

export default Section2;
